var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getSrc(_vm.array.lang))?_c('img',{attrs:{"src":_vm.getSrc(_vm.array.lang),"alt":""}}):_c('span',[_vm._v(" "+_vm._s(_vm.array.lang)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }